import React, { useEffect } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Process from "../components/Process";
import Members from "../components/Members";
import FrequentlyAsked from "../components/FrequentlyAsked";
import Footer from "../components/Footer";
import CTA from "../components/CTA";
import ButtonCta from "../components/ButtonCta";

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Header />
      <Hero />
      <Process />
      <Members />
      <CTA />
      <FrequentlyAsked />
      <ButtonCta />
      <Footer />
    </div>
  );
};

export default HomePage;
